import React from 'react';
import LanguageSelectFlag from '../flag';
const SingleValue = ({ value, label, iconComponent }) => (
  <div className="ws-ui-language-select-single-value" key={value}>
    <LanguageSelectFlag>{iconComponent}</LanguageSelectFlag>
    <div className="ws-ui-language-select-single-value__name">{label}</div>
  </div>
);

export default SingleValue;
